<template>
  <Layout>
    <PageHeader :title="page.title" :items="page.items" />

    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <b-col lg="3">
              <b-form-group
                label="Customer Name"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="customer-name"
              >
                <b-form-input
                  id="customer-name"
                  v-model="search_condition.brandName"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                label="Customer Area"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="customer-area"
              >
                <b-form-input
                  id="customer-area"
                  v-model="search_condition.cityName"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                label="Customer Type"
                label-cols-sm="4"
                label-align-sm="right"
              >
                <b-form-select
                  v-model="search_condition.customerType"
                  :options="types.customerTypes"
                  value-field="value"
                  text-field="text"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                label="Contacts"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="contacts"
              >
                <b-form-input
                  id="contacts"
                  v-model="search_condition.contactName"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                label="Contact Number"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="contact-number"
              >
                <b-form-input
                  id="contact-number"
                  v-model="search_condition.phone"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                label="Email"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="search_condition.email"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <!-- table -->
          <b-button
            v-has="'accounts::Create'"
            @click="gotoAdd"
            variant="primary"
            >Create</b-button
          >

          <div class="table-responsive mb-0">
            <b-table
              show-empty
              empty-text="no records"
              id="table"
              head-variant="light"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">
                {{
                  data.index +
                  (search_condition.pageNum - 1) * search_condition.pageSize +
                  1
                }}
              </template>

              <template v-slot:cell(contact)="data">
                <p v-if="data.item.contactName">
                  {{ data.item.contactName + "[" + data.item.phone + "]" }}
                </p>
              </template>

              <template v-slot:cell(actions)="row">
                <b-button-group>
                  <b-button
                    v-has="'accounts::Modify'"
                    size="sm"
                    variant="info"
                    @click="edit(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Modify
                  </b-button>
                  <b-button
                    v-has="'accounts::Details'"
                    size="sm"
                    variant="primary"
                    @click="show(row.item, row.index, $event.target)"
                    class="mr-1"
                    >Details</b-button
                  >
                </b-button-group>
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination mb-0" v-if="rows != 0">
                  <b-pagination
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  >
                  </b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * FAQ component
 */
export default {
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },
  data() {
    return {
      page: {
        title: "Accounts",
        items: [
          {
            text: "UNI-CORE",
            // href: "/"
          },
          {
            text: "Account Mgmt",
            // href: "/"
          },
          {
            text: "Accounts",
            active: true,
          },
        ],
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        { key: "brandName", label: "Customer Name", class: "text-center" },
        { key: "cityName", label: "Customer Area", class: "text-center" },
        {
          key: "customerType",
          label: "Customer Type",
          formatter: (value) => {
            return value == 1 ? "Channel" : value == 2 ? "Brands" : "Smoke oil";
          },
          class: "text-center",
        },
        { key: "contact", label: "Contact", class: "text-center" },
        { key: "email", label: "Email", class: "text-center" },
        { key: "remarks", label: "Notes", class: "text-center" },
        { key: "actions", label: "Opreration", class: "text-center" },
      ],
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        brandName: "",
        cityName: "",
        customerType: "",
        contactName: "",
        phone: "",
        email: "",
      },
      isBusy: false,
      has_data: false,
      types: {
        customerTypes: [
          { text: "Please select", value: "", disabled: false },
          { text: "Channel", value: 1, disabled: false },
          { text: "Brands", value: 2, disabled: false },
          { text: "Smoke oil", value: 3, disabled: false },
        ],
      },
    };
  },
  watch: {},
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {},
  created() {},
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    gotoAdd() {
      this.$router.push("accountsAdd");
    },
    provider(ctx) {
      this.isBusy = true;
      return this.$api.customerManage
        .list(this.search_condition, ctx)
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    edit(item, index, button) {
      this.$router.push("accountsEdit?id=" + item.id);
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
    },
    show(item, index, button) {
      this.$router.push("accountsInfo?id=" + item.id);
    },
  },
};
</script>
